import { AlertProvider, LanguageProvider } from "./utils/providers";
import PageSelector from "./pages/PageSelector";

const App = () => {
  return (
    <AlertProvider>
      <LanguageProvider>
        <PageSelector />
      </LanguageProvider>
    </AlertProvider>
  );
};

export default App;
